window.$ = require('jquery');

module.exports = {
    $mobileMenuContainer: null,
    $mobileMenu: null,
    toggleMenuButton: 'js-menu-mobile-toggle',
    mobileNavIsOpenClass: 'menu-mobile-nav-is-open',
    $header: null,

    init: function() {
        this.$body = window.shared.$body;
        this.$mobileMenuContainer = $('.js-menu-mobile');
        this.$mobileMenu = $('.js-menu-mobile-nav');
        this.$header = $('.js-header');

        $(window).on('scroll', this.createWindowScrollListener());
        this.$body.on('click', '.' + this.toggleMenuButton, this.createToggleMenuListener());
    },

    createWindowScrollListener: function() {
        var self = this;
        return function() {
            if ($(window).scrollTop() >= self.$header.outerHeight()) {
                self.$body.addClass('is-fixed');
            }
            else {
                self.$body.removeClass('is-fixed');
            }
        }
    },

    /**
     * Affiche le menu mobile
     *
     * @returns {Function}
     */
    createToggleMenuListener: function() {
        var self = this;
        return function(event) {
            event.preventDefault();
            var $button = $(this);
            if ($button.hasClass('is-open')) {
                $button.removeClass('is-open');
                self.$body.removeClass(self.mobileNavIsOpenClass);
                self.$mobileMenuContainer.removeClass('is-open');
                self.$mobileMenu.removeClass('is-open');
                $button.text('☰ MENU');
            }
            else {
                $button.addClass('is-open');
                self.$body.addClass(self.mobileNavIsOpenClass);
                self.$mobileMenuContainer.addClass('is-open');
                self.$mobileMenu.addClass('is-open');
                $button.text('✕ FERMER');
            }
        }
    },
};
